import AppHeader from "../../component/modules/appHeader/AppHeader";
import Footer from "../../component/modules/footer/Footer";
import OurServicesSection from "../../component/modules/ourServicesSection/OurServicesSection";
import HeroSection from "../../component/modules/heroSection/HeroSection";
import "./index.css";

const Services = () => {
  return (
    <div className="services_page_container">
      <AppHeader />
      <div className="services_content_container">
        <HeroSection
          headingpart1="Our"
          headingpart2="Services"
          description=" Comprehensive digital solutions designed to transform your
              business and drive sustainable growth in the digital landscape."
        />
        <OurServicesSection />
      </div>
      <Footer />
    </div>
  );
};

export default Services;
